import React from 'react';
import { motion } from 'framer-motion';
import useT from '../../../i18n';

/**
 * Two-way value proposition — For fagarbeidere ↔ For kommuner.
 * Desktop: 2-col split with thin vertical divider.
 * Mobile: stacked with horizontal divider between blocks.
 */
export default function TwoWayValue({ onProCta, onEmpCta }) {
  const t = useT();
  const v = t.landingV2.value;
  return (
    <section
      className="bg-paper py-section border-t border-ink/[0.06]"
      data-testid="landing-value"
    >
      <div className="max-w-editorial mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24">
          <Block
            testId="value-pro"
            data={v.pro}
            onCta={onProCta}
          />
          <div className="md:border-l md:border-ink/10 md:pl-16 lg:pl-20 relative">
            {/* Mobile: horizontal divider */}
            <div className="md:hidden border-t border-ink/10 -mt-8 mb-8" />
            <Block
              testId="value-emp"
              data={v.emp}
              onCta={onEmpCta}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function Block({ data, onCta, testId }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      data-testid={testId}
    >
      <p className="font-sans text-xs uppercase tracking-widest text-ink/50">
        {data.eyebrow}
      </p>
      <h2 className="mt-6 font-display font-light text-display-md text-ink whitespace-pre-line">
        {data.title}
      </h2>
      <p className="mt-6 font-sans text-base text-ink/70 leading-relaxed">
        {data.body}
      </p>

      <ul className="mt-8 space-y-3">
        {data.points.map((p, i) => (
          <li key={i} className="flex items-baseline gap-4">
            <span className="font-serif text-fjord select-none" aria-hidden>→</span>
            <span className="font-sans text-base text-ink/80">{p}</span>
          </li>
        ))}
      </ul>

      <button
        onClick={onCta}
        className="mt-10 inline-flex items-center gap-2 font-sans text-sm text-ink/70 hover:text-ink underline underline-offset-8 decoration-ink/20 hover:decoration-ink/40 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-fjord/40 focus-visible:ring-offset-4 focus-visible:ring-offset-paper rounded-sm"
        data-testid={`${testId}-cta`}
      >
        {data.cta} <span aria-hidden>→</span>
      </button>
    </motion.div>
  );
}
